/**
 * Event klien → GPT-Live lewat data channel. Murni (tanpa I/O) agar bentuknya
 * bisa diuji: `session.commentary.append` membawa jawaban backend untuk satu
 * delegasi; `session.instructions.append` menambah instruksi sesi (kata
 * pengisi #59) — `delegation_id: null` karena tidak terikat delegasi.
 */

export type CommentaryEvent = {
	type: "session.commentary.append";
	event_id: string;
	delegation_id: string;
	content: string;
};

export type InstructionsAppendEvent = {
	type: "session.instructions.append";
	event_id: string;
	delegation_id: null;
	content: string;
};

export const voiceEventId = (prefix: string) =>
	`${prefix}_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;

export function commentaryEvent(
	delegationId: string,
	content: string,
): CommentaryEvent {
	return {
		type: "session.commentary.append",
		event_id: voiceEventId("cmt"),
		delegation_id: delegationId,
		content,
	};
}

/** null bila tidak ada instruksi (tidak perlu dikirim). */
export function instructionsAppendEvent(
	content: string,
): InstructionsAppendEvent | null {
	if (!content.trim()) return null;
	return {
		type: "session.instructions.append",
		event_id: voiceEventId("ins"),
		delegation_id: null,
		content,
	};
}
